import { keyframes } from 'styled-components';

export const spin = keyframes`
to{
  transform: rotate(360deg);
}`;
